import React from 'react'
import { Image, ImageStyle, View } from 'react-native'
import { useNavigation } from '@react-navigation/native'
import { StyleService, useStyleSheet } from '@src/style/service'
import { calendarHeartImage } from '@src/assets/images'
import { Button, Text } from '@src/components/base'

export const NoLabResultsProvidedComponent = () => {
  const styles = useStyleSheet(themedStyles)
  const navigation = useNavigation()

  return (
    <View style={styles.content}>
      <Image
        style={styles.calendarHeartImage as ImageStyle}
        source={calendarHeartImage.imageSource}
      />
      <Text type="title-3" style={styles.titleText}>
        No lab results submitted
      </Text>
      <Text type="large" style={styles.contentText}>
        Please share your lab results to track all your data and keep progress of your health
        outcomes.
      </Text>
      <Button
        type="primary"
        size="block"
        accessibilityLabel="Add Lab Results"
        onPress={() => navigation.navigate('AddLabResults')}
      >
        Add lab results
      </Button>
    </View>
  )
}

const themedStyles = StyleService.create({
  content: {
    alignItems: 'center',
    paddingHorizontal: 16,
  },
  calendarHeartImage: {
    marginTop: 56,
    marginBottom: 48,
  },
  titleText: {
    textAlign: 'center',
    marginBottom: 32,
  },
  contentText: {
    textAlign: 'center',
    marginBottom: 48,
  },
})
